import { render, staticRenderFns } from "./ModalSolicitacoes.vue?vue&type=template&id=05e7d8e6&"
import script from "./ModalSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./ModalSolicitacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports